export const ERRO = "ERRO";

export const SUCESSO = "SUCESSO";
